module.exports = __webpack_public_path__ + "static/media/DSCF0136.3657b039.jpg";